import React, { useEffect } from "react";
import {
  Container,
  Grid,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  Divider,
} from "@mui/material";

import { useRouter } from "next/router";

import { SharedBookReducerProvider, useSharedBookReducer } from "./state";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

import { isNumber, toInteger } from "lodash";
import currency from "currency.js";
import moment from "moment";

import { request, gql } from "graphql-request";

import { ContactInfo } from "./ContactInfo";
import { Card } from "./Card";
import { Promocode } from "./Promocode";
import { SidebarHelp } from "./SidebarHelp";
import { SidebarNotes } from "./SidebarNotes";
import { SurfMainType } from "./SurfMainType";
import { SurfAbout } from "./SurfAbout";
import { SurfExperienceLevel } from "./SurfExperienceLevel";
import { SurfDatesAndTimes } from "./SurfDatesAndTimes";
import { SurfGroupCount } from "./SurfGroupCount";
import { SurfJoinCount } from "./SurfJoinCount";
import { SurfLargeGroupCount } from "./SurfLargeGroupCount";

import { SignupCard } from "./SignupCard";
import { SignupPartnerPkg } from "./SignupPartnerPkg";
import { SignupContactInfo } from "./SignupContactInfo";

import { useForm, useFormContext, FormProvider } from "react-hook-form";

const BikeReserve = (props) => {
  return (
    <SharedBookReducerProvider initialState={{}}>
      <BikeReserveWrapped />
    </SharedBookReducerProvider>
  );
};

const BikeReserveWrapped = (props) => {
  const stripe = useStripe();
  const elements = useElements();

  const [bookState, dispatch] = useSharedBookReducer();

  //   console.log("bookstate:", bookState);
  return (
    <div style={{ padding: "24px 0" }}>
      <Grid container spacing={3}>
        <Grid item md={7}>
          <Typography variant="h5">
            We apologize, but our biking payment page is unavailable.
            <br />
            <br />
            Please contact us at <a href="+18312648008">
              (831) 264-8008{" "}
            </a> or{" "}
            <a href="mailto:hello@bigsurfadventures.com">
              hello@bigsurfadventures.com
            </a>{" "}
            and we'll be able to help you reserve an amazing bike adventure
            experience!
          </Typography>
        </Grid>
        <Grid item md={4}>
          {/* <SidebarHelp /> */}
        </Grid>
      </Grid>
    </div>
  );
};

export default BikeReserve;
